import { gql } from '@apollo/client';

export const GET_USER_PREFERENCES = gql`
  query getUserPreferences {
    getUserPreferences {
      language {
        code
        name
      }
      community {
        distance
        metricType
        placeId
        address
        localArea
        location {
          lat
          lng
        }
        isSaved
        flyerCounters {
          name
          frequency
          amount
        }
      }
      disclaimer {
        version
        acceptedAt
      }
    }
  }
`;
